<template>
  <QueueWrapper>
    <div class="d-flex flex-column gap-4">
      <div class="d-flex flex-wrap justify-content-between rounded-30 gap-2">
        <div class="d-flex my-auto gap-2">
          <h1 class="queue-page-header-text">{{ pageHeader }}</h1>
        </div>
      </div>
      <QueueTimingsContainer />
      <QueueLocationsContainer />
    </div>
  </QueueWrapper>
</template>

<script>
import queueConfigs from "@/configs/queueConfigs"
import QueueLocationsContainer from "@/v3components/Queue/QueueLocation/QueueLocationsContainer.vue"
import QueueTimingsContainer from "@/v3components/Queue/QueueTime/QueueTimingsContainer.vue"
import QueueWrapper from "@/v3components/QueueWrapper.vue"

export default {
  name: "QueueSettings",
  components: {
    QueueWrapper,
    QueueTimingsContainer,
    QueueLocationsContainer
  },
  setup() {
    return {
      pageHeader: queueConfigs.pages.settingsPage().name
    }
  }
}
</script>
